<template>
  <div class="flex-col">
    <div class="uppercase md:mb-2 sm:mb-4">
      {{ label }}
    </div>
    <div class="flex items-center justify-center">
      <div
        @click="down"
        class="cursor-pointer mr-2">
        <img :src="minusBtn" alt="">
      </div>
      <div class="w-1/4">
        <input readonly v-model="currentValue" type="text"
          class="border border-grey rounded-lg md:h-12 w-full text-center
          md:font-bold md:text-base sm:text-2xl h-16">
      </div>
      <div
        @click="up"
        class="cursor-pointer ml-2">
        <img :src="plusBtn" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import plusBtn from '@/assets/plus_btn.gif'
import minusBtn from '@/assets/minus_btn.gif'

export default {
  name: 'NumberSelector',
  props: ['label', 'min', 'max'],
  data () {
    return {
      plusBtn,
      minusBtn,
      currentValue: 0
    }
  },
  methods: {
    getValue () {
      return parseInt(this.currentValue)
    },
    up () {
      this.currentValue++
    },
    down () {
      if (--this.currentValue < 0) {
        this.currentValue = 0
      }
    },
    reset () {
      this.currentValue = 0
    }
  }
}
</script>
